export default {
  custom_additive: {
    placeholder: 'Lisää oma vaihtoehto',
  },
  buttons: {
    add: 'Lisää',
  },
};
